export function withGoogleAccountChooser(rawUrl) {
  try {
    const url = new URL(rawUrl);
    if (url.hostname.includes("google.") || url.hostname === "accounts.google.com") {
      url.searchParams.set("prompt", "select_account");
    }
    return url.toString();
  } catch {
    return rawUrl;
  }
}
